// A national ID (a person's PINFL, a company's TIN) as the UI shows it,
// whoever it belongs to — the user's own certificates included: the first two
// and last two digits, the rest hidden. The backend masks the same way
// (mask_national_id), so masking a value it already masked changes nothing.

export const MASK_CHAR = '•';

export function maskNationalId(value) {
  if (value == null) return '';
  const text = String(value).trim();
  if (!text) return '';
  if (text.length <= 4) return MASK_CHAR.repeat(text.length);
  return `${text.slice(0, 2)}${MASK_CHAR.repeat(text.length - 4)}${text.slice(-2)}`;
}

/**
 * Whether two national IDs may be the same number, judged by what the UI is
 * allowed to hold: their masked forms. Good enough to pick which of the
 * user's own certificates fits a signing slot; who the user IS comes from
 * the server (`is_me`), and the server checks the signature again.
 */
export function nationalIdsMayMatch(a, b) {
  const left = maskNationalId(a);
  return Boolean(left) && left === maskNationalId(b);
}
